/**
 * How a distribution is written for a person.
 *
 * `SAAS` is an enum member; "SaaS" is what it is called. Showing the raw value
 * in a table is the kind of small thing that makes an admin console feel like a
 * database browser.
 */
export const DISTRIBUTIONS = [
  'SAAS',
  'DESKTOP',
  'MOBILE',
  'CLI',
  'API',
  'SERVER',
  'EMBEDDED',
  'HYBRID',
  'CUSTOM',
] as const;

export type Distribution = (typeof DISTRIBUTIONS)[number];

const LABELS: Readonly<Record<Distribution, string>> = {
  SAAS: 'SaaS',
  DESKTOP: 'Desktop',
  MOBILE: 'Mobile',
  CLI: 'CLI',
  API: 'API',
  SERVER: 'Server',
  EMBEDDED: 'Embedded',
  HYBRID: 'Hybrid',
  CUSTOM: 'Custom',
};

export function distributionLabel(value: string): string {
  return LABELS[value as Distribution] ?? value;
}
